module.exports = __webpack_public_path__ + "static/media/course-badge-1.6f9fcea5.svg";